<template>
  <div v-if="loading" class="p-12 text-center">
    <Loader />
  </div>
  <div v-else>
    <VHeader :project="project" />
    <VNavigation />
    <div class="p-4 lg:p-12">
      <div class="max-w-7xl mx-auto">
        <router-view />
      </div>
    </div>
  </div>
</template>
<script>
import VHeader from '@/components/AccountProjects/Show/SettingsHeader.vue';
import VNavigation from '@/components/AccountProjects/Show/SettingsNavigation.vue';

export default {
  name: 'ProjectSettings',

  components: {
    VHeader,
    VNavigation,
  },

  props: {
    projectId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    loading: false,
  }),

  computed: {
    project() {
      return this.$store.state.entities.projects.byId[this.projectId];
    },
  },

  created() {
    if (!this.project) {
      this.fetchProject();
    }
  },

  methods: {
    async fetchProject() {
      try {
        this.loading = true;

        await this.$store.dispatch({
          type: 'ui/projects/read',
          projectUuid: this.projectId,
          params: { include: 'owner,product' },
        });

        this.loading = false;
      } catch (error) {
        this.$router.back();
      }
    },
  },
};
</script>
